import { render, staticRenderFns } from "./exception-list.vue?vue&type=template&id=88b61672"
import script from "./exception-list.vue?vue&type=script&lang=js"
export * from "./exception-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88b61672')) {
      api.createRecord('88b61672', component.options)
    } else {
      api.reload('88b61672', component.options)
    }
    module.hot.accept("./exception-list.vue?vue&type=template&id=88b61672", function () {
      api.rerender('88b61672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/email-bulk-message/exception-list.vue"
export default component.exports